/**
 * Invoice module theme — aliases app brand (Patient indigo SoT).
 */
import { BRAND_THEME, BRAND_THEME_HEX } from "../../ui/brandTheme";

export const INVOICE_THEME = BRAND_THEME;
export const INVOICE_THEME_HEX = BRAND_THEME_HEX;

export const INVOICE_ROLE_CHIP =
  "bg-indigo-50 text-indigo-700 border border-indigo-100";

export const INVOICE_BTN = {
  soft: `inline-flex items-center justify-center gap-1 h-6 px-2 text-[11px] font-medium rounded border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.soft}`,
  outline: `inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-medium rounded-md border transition-colors disabled:opacity-50 ${BRAND_THEME.button.outline}`,
  primary: `inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-semibold rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.primary}`,
  icon: `inline-flex h-7 w-7 items-center justify-center rounded-md border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.soft}`,
  iconDanger:
    "inline-flex h-7 w-7 items-center justify-center rounded-md border border-red-200 bg-red-50 text-red-700 hover:bg-red-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
  danger:
    "inline-flex items-center justify-center gap-1 h-6 px-2 text-[11px] font-medium rounded border border-red-200 bg-red-50 text-red-700 hover:bg-red-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
  clear:
    "inline-flex items-center gap-1 h-8 px-2.5 text-xs font-medium text-indigo-700 hover:bg-indigo-50 rounded-md border border-indigo-200 transition-colors whitespace-nowrap",
  modalPrimary: `inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-semibold rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.primary}`,
  modalCancel:
    "inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-medium rounded-md border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 disabled:opacity-50",
  modalDanger:
    "inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-semibold rounded-md bg-red-600 text-white hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
};

export const INVOICE_FIELD = {
  label: "block text-[11px] font-medium text-slate-700 mb-1 uppercase tracking-wide",
  search: `w-full h-8 pl-9 pr-8 text-sm bg-white border border-indigo-200 rounded-md text-slate-800 placeholder:text-slate-400 outline-none transition-colors ${BRAND_THEME.fieldFocus}`,
  select: `appearance-none h-8 min-w-[130px] pl-3 pr-8 text-sm rounded-md border border-indigo-200 text-slate-700 bg-white outline-none cursor-pointer transition-colors ${BRAND_THEME.fieldFocus}`,
  selectActive:
    "border-indigo-400 text-indigo-700 font-medium bg-indigo-50/60",
  input: `w-full h-9 pl-8 pr-3 text-sm rounded-md border border-indigo-200 bg-white text-slate-800 outline-none transition-colors ${BRAND_THEME.fieldFocus}`,
  textarea: `w-full min-h-[72px] px-3 py-2 text-sm rounded-md border border-indigo-200 bg-white text-slate-800 outline-none transition-colors resize-y ${BRAND_THEME.fieldFocus}`,
};

export const INVOICE_SECTION_TITLE =
  "text-base font-semibold text-slate-900 mb-3";

export const INVOICE_MODAL = {
  backdrop:
    "fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40",
  panel:
    "w-full max-w-6xl rounded-xl border border-indigo-200 bg-white shadow-xl overflow-visible max-h-[90vh] flex flex-col",
  panelSm:
    "w-full max-w-md rounded-xl border border-indigo-200 bg-white shadow-xl overflow-hidden max-h-[90vh] flex flex-col",
  head: `flex items-start justify-between gap-3 px-4 py-3 border-b shrink-0 ${BRAND_THEME.modalHead}`,
  title: `text-sm font-semibold uppercase tracking-wide ${BRAND_THEME.modalTitle}`,
  subtitle: "mt-0.5 text-[11px] text-slate-600 normal-case tracking-normal font-normal",
  body: "p-4 overflow-y-auto flex-1 space-y-4",
  footer:
    "flex items-center justify-end gap-2 px-4 py-3 border-t border-indigo-100 bg-indigo-50/40 shrink-0",
  close:
    "inline-flex h-7 w-7 items-center justify-center rounded-md text-slate-500 hover:bg-indigo-50 hover:text-indigo-700 transition-colors shrink-0",
};

/** List table widths for `table-fixed` (checkbox + Sr. No. via Table). */
export const INVOICE_COL = {
  number: "w-[8%] min-w-0 pl-2 pr-2 align-middle",
  created: "w-[10%] whitespace-nowrap px-2 align-middle",
  employee: "w-[12%] min-w-0 px-2 align-middle",
  role: "w-[7%] whitespace-nowrap px-2 align-middle",
  period: "w-[14%] whitespace-nowrap px-2 align-middle",
  due: "w-[10%] whitespace-nowrap px-2 align-middle",
  notes: "w-[12%] min-w-0 px-2 align-middle",
  flags: "w-[8%] whitespace-nowrap px-2 align-middle",
  amount: "w-[10%] whitespace-nowrap px-2 align-middle",
  actions: "w-[8%] whitespace-nowrap pl-2 pr-3 text-right align-middle",
};
